module.exports = __webpack_public_path__ + "static/media/cep.bd843340.jpg";